<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="工號">
              <j-input placeholder="請輸入工號" v-model="queryParam.empNo"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="站點code">
              <j-input placeholder="請輸入站點code" v-model="queryParam.webSiteCode"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="站點url">
              <j-input placeholder="請輸入站點url" v-model="queryParam.webSiteUrl"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="刪除标示">
              <a-select v-model="queryParam.delFlag" placeholder="請選擇刪除标示" allowClear>
                <a-select-option value="0">0</a-select-option>
                <a-select-option value="1">1</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="資料來源">
              <a-select v-model="queryParam.fromSource" placeholder="請選擇資料來源" allowClear>
                <a-select-option value="dhr">dhr</a-select-option>
                <a-select-option value="a-eisp">a-eisp</a-select-option>
                <a-select-option value="b-eisp">b-eisp</a-select-option>
                <a-select-option value="c-chrm">c-chrm</a-select-option>
                <a-select-option value="jusda">jusda</a-select-option>
                <a-select-option value="rayprus">rayprus</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查詢</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>-->
      <a-button type="primary" icon="download" @click="handleExportXls('emp_website_mapping')">导出</a-button>

      <a-button type="primary" icon="search" @click="showMissingRecordsModal" style="margin-left: 8px">查詢缺失記錄</a-button>
      <a-button type="primary" icon="warning" @click="showEmptyWebSiteCodeModal" style="margin-left: 8px">查詢異常站點code記錄</a-button>

      <a-button type="primary" @click="showAcquireDataModal" icon="reload" style="margin-left: 8px">by條件抓取數據</a-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <emp-website-mapping-modal ref="modalForm" @ok="modalFormOk"></emp-website-mapping-modal>

    <!-- 缺失记录弹窗 -->
    <a-modal
      title="缺失記錄查詢"
      :visible="missingRecordsModalVisible"
      @cancel="closeMissingRecordsModal"
      :width="1200"
      :footer="null"
      :maskClosable="false">

      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="工號">
                <j-input placeholder="請輸入工號" v-model="missingQueryParams.empNo"></j-input>
              </a-form-item>
            </a-col>
<!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="資料來源">
                <a-select v-model="missingQueryParams.fromSource" placeholder="請選擇資料來源" allowClear>
                  <a-select-option value="dhr">dhr</a-select-option>
                  <a-select-option value="a-eisp">a-eisp</a-select-option>
                  <a-select-option value="b-eisp">b-eisp</a-select-option>
                  <a-select-option value="c-chrm">c-chrm</a-select-option>
                  <a-select-option value="jusda">jusda</a-select-option>
                  <a-select-option value="rayprus">rayprus</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchMissingRecords" icon="search">查詢</a-button>
                <a-button type="primary" @click="resetMissingQuery" icon="reload" style="margin-left: 8px">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <p>1. 【抓取缺失】：抓取當前工號缺失的站點code 2.【重新抓取】：重新抓取當前工號所有的站點code 3.【重新抓取當前】：重新抓取當前工號當前來源的站點code】</p>
      </div>
      <a-table
        ref="missingTable"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="missingColumns"
        :dataSource="missingRecordsData"
        :pagination="missingPagination"
        :loading="missingRecordsLoading"
        class="j-table-force-nowrap"
        @change="handleMissingTableChange">

        <span slot="missingAction" slot-scope="text, record">
          <a @click="handleMissingData(record)">抓取缺失</a>
          <a-divider type="vertical" />
          <a @click="handleReacquireData(record)">重新抓取</a>
          <a-divider type="vertical" />
          <a @click="handleReacquireSourceData(record)">重新抓取當前</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </a-modal>

    <!-- 空站點code记录弹窗 -->
    <a-modal
      title="異常站點code記錄查詢"
      :visible="emptyWebSiteCodeModalVisible"
      @cancel="closeEmptyWebSiteCodeModal"
      :width="1200"
      :footer="null"
      :maskClosable="false">

      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="工號">
                <j-input placeholder="請輸入工號" v-model="emptyQueryParams.empNo"></j-input>
              </a-form-item>
            </a-col>
<!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="資料來源">
                <a-select v-model="emptyQueryParams.fromSource" placeholder="請選擇資料來源" allowClear>
                  <a-select-option value="dhr">dhr</a-select-option>
                  <a-select-option value="a-eisp">a-eisp</a-select-option>
                  <a-select-option value="b-eisp">b-eisp</a-select-option>
                  <a-select-option value="c-chrm">c-chrm</a-select-option>
                  <a-select-option value="jusda">jusda</a-select-option>
                  <a-select-option value="rayprus">rayprus</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchEmptyWebSiteCodeRecords" icon="search">查詢</a-button>
                <a-button type="primary" @click="resetEmptyQuery" icon="reload" style="margin-left: 8px">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <p>1. 【抓取缺失】：抓取當前工號缺失的站點code 2.【重新抓取】：重新抓取當前工號所有的站點code 3.【重新抓取當前】：重新抓取當前工號當前來源的站點code】</p>
      </div>
      <a-table
        ref="emptyTable"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="emptyColumns"
        :dataSource="emptyWebSiteCodeData"
        :pagination="emptyPagination"
        :loading="emptyWebSiteCodeLoading"
        class="j-table-force-nowrap"
        @change="handleEmptyTableChange">
         <span slot="emptyAction" slot-scope="text, record">
          <a @click="handleMissingData(record)">抓取缺失</a>
          <a-divider type="vertical" />
          <a @click="handleReacquireData(record)">重新抓取</a>
          <a-divider type="vertical" />
          <a @click="handleReacquireSourceData(record)">重新抓取當前</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </a-modal>

    <a-modal
      title="數據抓取"
      :visible="acquireDataModalVisible"
      @cancel="closeAcquireDataModal"
      :width="800"
      :footer="null"
      :maskClosable="false">

      <a-form layout="vertical">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-alert message="根據條件抓取數據，請謹慎操作！" type="warning" show-icon />
          </a-col>

          <a-col :span="24">
            <a-form-item label="抓取類型">
              <a-radio-group v-model="acquireParams.acquireType">
                <a-radio value="missing">抓取所有缺失</a-radio>
                <a-radio value="error">重抓所有異常</a-radio>
                <a-radio value="multiEmp">多工號抓取</a-radio>
                <a-radio value="condition">根據條件重新抓取</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <template v-if="acquireParams.acquireType === 'multiEmp'">
            <a-col :span="24">
              <a-form-item label="工號列表（多個工號請用逗號分隔）">
                <a-textarea
                  v-model="acquireParams.empNos"
                  placeholder="請輸入工號，多個工號請用逗號分隔，如：001,002,003"
                  :rows="4" />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item label="資料來源">
                <a-select v-model="acquireParams.fromSource" placeholder="請選擇資料來源" allowClear>
                  <a-select-option value="dhr">dhr</a-select-option>
                  <a-select-option value="a-eisp">a-eisp</a-select-option>
                  <a-select-option value="b-eisp">b-eisp</a-select-option>
                  <a-select-option value="c-chrm">c-chrm</a-select-option>
                  <a-select-option value="jusda">jusda</a-select-option>
                  <a-select-option value="rayprus">rayprus</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <template v-if="acquireParams.acquireType === 'condition'">
            <a-col :span="12">
              <a-form-item label="開始時間">
                <a-date-picker
                  v-model="acquireParams.startTime"
                  placeholder="請選擇開始時間"
                  style="width: 100%"
                  :format="dateFormat" />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item label="結束時間">
                <a-date-picker
                  v-model="acquireParams.endTime"
                  placeholder="請選擇結束時間"
                  style="width: 100%"
                  :format="dateFormat" />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item label="工號">
                <a-input placeholder="請輸入工號" v-model="acquireParams.empNo"></a-input>
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item label="資料來源">
                <a-select v-model="acquireParams.fromSource" placeholder="請選擇資料來源" allowClear>
                  <a-select-option value="dhr">dhr</a-select-option>
                  <a-select-option value="a-eisp">a-eisp</a-select-option>
                  <a-select-option value="b-eisp">b-eisp</a-select-option>
                  <a-select-option value="c-chrm">c-chrm</a-select-option>
                  <a-select-option value="jusda">jusda</a-select-option>
                  <a-select-option value="rayprus">rayprus</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :span="24">
            <div style="text-align: center; margin-top: 20px;">
              <a-button type="primary" @click="handleAcquireData" :loading="acquireDataLoading">執行抓取</a-button>
              <a-button @click="closeAcquireDataModal" style="margin-left: 20px">取消</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpWebsiteMappingModal from './modules/EmpWebsiteMappingModal'
  import { getAction } from '@/api/manage'

  export default {
    name: 'EmpWebsiteMappingList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpWebsiteMappingModal
    },
    data () {
      return {
        description: 'emp_website_mapping管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'工號',
            align:"center",
            dataIndex: 'empNo',
            sorter: true
          },
          {
            title:'站點code',
            align:"center",
            dataIndex: 'webSiteCode',
            sorter: true
          },
          {
            title:'站點url',
            align:"center",
            dataIndex: 'webSiteUrl',
            sorter: true
          },
          {
            title:'資料來源',
            align:"center",
            dataIndex: 'fromSource',
            sorter: true
          },
          {
            title:'創建時間',
            align:"center",
            dataIndex: 'createTime',
            sorter: true,
            width: 180,
            customRender:function (text) {
              return !text?"":(text.length>19?text.substr(0,19):text)
            }
          },
          {
            title:'刪除标示',
            align:"center",
            dataIndex: 'delFlag'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 缺失记录表头
        missingColumns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'工號',
            align:"center",
            dataIndex: 'empNo'
          },
          {
            title:'站點code',
            align:"center",
            dataIndex: 'webSiteCode'
          },
          {
            title:'站點url',
            align:"center",
            dataIndex: 'webSiteUrl'
          },
          {
            title:'實際數量',
            align:"center",
            dataIndex: 'actualCount'
          },
          {
            title:'期望數量',
            align:"center",
            dataIndex: 'expectedCount'
          },
          {
            title:'資料來源',
            align:"center",
            dataIndex: 'fromSource'
          },
          {
            title:'創建時間',
            align:"center",
            dataIndex: 'createTime',
            width: 180,
            customRender:function (text) {
              return !text?"":(text.length>19?text.substr(0,19):text)
            }
          },
          {
            title:'刪除标示',
            align:"center",
            dataIndex: 'delFlag'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'missingAction' }
          }
        ],
        // 空站點code记录表头
        emptyColumns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'工號',
            align:"center",
            dataIndex: 'empNo'
          },
          {
            title:'站點code',
            align:"center",
            dataIndex: 'webSiteCode'
          },
          {
            title:'站點url',
            align:"center",
            dataIndex: 'webSiteUrl'
          },
          {
            title:'資料來源',
            align:"center",
            dataIndex: 'fromSource'
          },
          {
            title:'異常類型',
            align:"center",
            dataIndex: 'errorType'
          },
          {
            title:'創建時間',
            align:"center",
            dataIndex: 'createTime',
            width: 180,
            customRender:function (text) {
              return !text?"":(text.length>19?text.substr(0,19):text)
            }
          },
          {
            title:'刪除标示',
            align:"center",
            dataIndex: 'delFlag'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'emptyAction' }
          }
        ],

        dateFormat: 'YYYY-MM-DD',

        // 數據抓取弹窗相关数据
        acquireDataModalVisible: false,
        acquireDataLoading: false,
        acquireParams: {
          acquireType: 'missing', // missing, error, multiEmp, condition
          startTime: null,
          endTime: null,
          empNo: '',
          empNos: '', // 多工号字段
          fromSource: undefined
        },

        url: {
          list: "/hhemp/sitemapping/empwebsitemappings",
          delete: "/hhemp/sitemapping/empwebsitemapping",
          deleteBatch: "/hhemp/sitemapping/empwebsitemapping/batch",
          exportXlsUrl: "/hhemp/sitemapping/export-xls",
          importExcelUrl: "hhemp/sitemapping/import-excel",
          missingRecords: "/hhemp/sitemapping/missing-records",
          errorWebSiteCode: "/hhemp/sitemapping/error-records",
          acquireMissing: "/hhemp/sitemapping/acquire-missing",
          reacquireAll: "/hhemp/sitemapping/reacquire-all",
          reacquireSource: "/hhemp/sitemapping/reacquire-source",

          acquireMissingAll: "/hhemp/sitemapping/acquire-missing-all",
          acquireError: "/hhemp/sitemapping/acquire-error",
          acquireMultiEmp: "/hhemp/sitemapping/acquire-multiemp",
          acquireByCondition: "/hhemp/sitemapping/acquire-by-condition",
        },
        dictOptions:{},
        superFieldList:[],

        // 缺失记录弹窗相关数据
        missingRecordsModalVisible: false,
        missingRecordsData: [],
        missingRecordsLoading: false,
        missingQueryParams: {},
        missingPagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },

        // 異常站點code记录弹窗相关数据
        emptyWebSiteCodeModalVisible: false,
        emptyWebSiteCodeData: [],
        emptyWebSiteCodeLoading: false,
        emptyQueryParams: {},
        emptyPagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        }


      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },

      // 显示缺失记录弹窗
      showMissingRecordsModal() {
        this.missingRecordsModalVisible = true;
        this.searchMissingRecords();
      },

      // 关闭缺失记录弹窗
      closeMissingRecordsModal() {
        this.missingQueryParams = {};
        this.missingPagination.current = 1;
        this.missingRecordsModalVisible = false;
      },

      // 查询缺失记录
      searchMissingRecords() {
        this.missingRecordsLoading = true;
        const params = Object.assign({}, this.missingQueryParams, {
          pageNo: this.missingPagination.current,
          pageSize: this.missingPagination.pageSize
        });

        getAction(this.url.missingRecords, params).then(res => {
          if (res.success) {
            this.missingRecordsData = res.result.records;
            this.missingPagination.total = res.result.total;
          } else {
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.missingRecordsLoading = false;
        });
      },

      // 重置缺失记录查询条件
      resetMissingQuery() {
        this.missingQueryParams = {};
        this.missingPagination.current = 1;
        this.searchMissingRecords();
      },

      // 缺失记录表格分页变化
      handleMissingTableChange(pagination) {
        this.missingPagination.current = pagination.current;
        this.missingPagination.pageSize = pagination.pageSize;
        this.searchMissingRecords();
      },

      // 显示空站點code记录弹窗
      showEmptyWebSiteCodeModal() {
        this.emptyWebSiteCodeModalVisible = true;
        this.searchEmptyWebSiteCodeRecords();
      },

      // 关闭空站點code记录弹窗
      closeEmptyWebSiteCodeModal() {
        this.emptyQueryParams = {};
        this.emptyPagination.current = 1;
        this.emptyWebSiteCodeModalVisible = false;
      },

      // 查询空站點code记录
      searchEmptyWebSiteCodeRecords() {
        this.emptyWebSiteCodeLoading = true;
        const params = Object.assign({}, this.emptyQueryParams, {
          pageNo: this.emptyPagination.current,
          pageSize: this.emptyPagination.pageSize
        });

        getAction(this.url.errorWebSiteCode, params).then(res => {
          if (res.success) {
            this.emptyWebSiteCodeData = res.result.records;
            this.emptyPagination.total = res.result.total;
          } else {
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.emptyWebSiteCodeLoading = false;
        });
      },

      // 重置空站點code记录查询条件
      resetEmptyQuery() {
        this.emptyQueryParams = {};
        this.emptyPagination.current = 1;
        this.searchEmptyWebSiteCodeRecords();
      },

      // 空站點code记录表格分页变化
      handleEmptyTableChange(pagination) {
        this.emptyPagination.current = pagination.current;
        this.emptyPagination.pageSize = pagination.pageSize;
        this.searchEmptyWebSiteCodeRecords();
      },
      // 抓取缺失数据
      handleMissingData(record) {
        // 调用后端API抓取缺失的数据
        getAction("/hhemp/sitemapping/acquire-missing", {
          empNo: record.empNo
        }).then(res => {
          if (res.success) {
            this.$message.success("抓取缺失數據成功");
            // 刷新当前表格数据
            this.searchMissingRecords();
          } else {
            this.$message.error(res.message);
          }
        }).catch(err => {
          this.$message.error("抓取缺失數據失敗: " + err.message);
        });
      },

// 重新抓取所有数据
      handleReacquireData(record) {
        const that = this;
        this.$confirm({
          title: "確認重新抓取",
          content: "確定要重新抓取工號 " + record.empNo + " 的所有站點code數據嗎？這將覆蓋現有數據！",
          onOk() {
            // 调用后端API重新抓取所有数据
            getAction("/hhemp/sitemapping/reacquire-all", {
              empNo: record.empNo
            }).then(res => {
              if (res.success) {
                that.$message.success("重新抓取數據成功");
                // 刷新当前表格数据
                that.searchMissingRecords();
              } else {
                that.$message.error(res.message);
              }
            }).catch(err => {
              that.$message.error("重新抓取數據失敗: " + err.message);
            });
          }
        });
      },

// 重新抓取当前来源数据
      handleReacquireSourceData(record) {
        const that = this;
        this.$confirm({
          title: "確認重新抓取",
          content: "確定要重新抓取工號 " + record.empNo + " 來源為 " + record.fromSource + " 的站點code數據嗎？這將覆蓋現有數據！",
          onOk() {
            // 调用后端API重新抓取当前来源数据
            getAction("/hhemp/sitemapping/reacquire-source", {
              empNo: record.empNo,
              fromSource: record.fromSource
            }).then(res => {
              if (res.success) {
                that.$message.success("重新抓取當前來源數據成功");
                // 刷新当前表格数据
                that.searchMissingRecords();
              } else {
                that.$message.error(res.message);
              }
            }).catch(err => {
              that.$message.error("重新抓取當前來源數據失敗: " + err.message);
            });
          }
        });
      },


      // 显示数据抓取弹窗
      showAcquireDataModal() {
        this.acquireDataModalVisible = true;
      },

// 关闭数据抓取弹窗
      closeAcquireDataModal() {
        this.acquireDataModalVisible = false;
        // 重置表单数据
        this.acquireParams = {
          acquireType: 'missing',
          startTime: null,
          endTime: null,
          empNo: '',
          fromSource: undefined
        };
      },

// 执行数据抓取
      handleAcquireData() {
        const that = this;
        this.$confirm({
          title: "確認執行數據抓取",
          content: "確定要執行數據抓取操作嗎？這可能會覆蓋現有數據，請謹慎操作！",
          onOk() {
            that.acquireDataLoading = true;

            // 根据不同的抓取类型调用不同的接口
            let url = "";
            let params = {};

            switch (that.acquireParams.acquireType) {
              case 'missing':
                url = that.url.acquireMissing;
                break;
              case 'error':
                url = that.url.acquireError;
                break;
              case 'multiEmp':
                url = that.url.acquireMultiEmp; // 使用条件抓取接口
                // 处理多个工号
                let empNos = that.acquireParams.empNos; //? that.acquireParams.empNos.split(',').map(empNo => empNo.trim()) : [];
                params = {
                  empNos: empNos,
                  fromSource: that.acquireParams.fromSource
                };
                break;
              case 'condition':
                url = that.url.acquireByCondition;
                params = {
                  startTime: that.acquireParams.startTime ? that.acquireParams.startTime.format(that.dateFormat) : null,
                  endTime: that.acquireParams.endTime ? that.acquireParams.endTime.format(that.dateFormat) : null,
                  empNo: that.acquireParams.empNo,
                  fromSource: that.acquireParams.fromSource
                };
                break;
            }

            getAction(url, params).then(res => {
              if (res.success) {
                that.$message.success("數據抓取成功");
                that.closeAcquireDataModal();
              } else {
                that.$message.error(res.message);
              }
            }).catch(err => {
              that.$message.error("數據抓取失敗: " + err.message);
            }).finally(() => {
              that.acquireDataLoading = false;
            });
          }
        });
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
